import React from 'react';
import BootstrapLoadingButton from "../../Ui/BootstrapLoadingButton";
import {makeStyles} from "@material-ui/core/styles";
import {LOAD_FICHE_COMMENTS} from "../../../api/Api";
import axios from 'axios';
import CircularProgress from "@material-ui/core/CircularProgress";
import * as Yup from 'yup';
import {Field, Formik} from "formik";
import clsx from "clsx";
import moment from "moment";

const useStyles = makeStyles(theme => ({
    comment: {
        width: '100%',
        border: 'none',
        borderRadius: 8,
        backgroundColor: '#f3f6f9',
        padding: 32,
    }
}));


export default function FicheCommentSection(props){

    const classes = useStyles();

    const {fiche} = props;

    const [comment,setComment] = React.useState();

    const [isPostingComments,setIsPostingComments] = React.useState(false)
    const [isLoadingComments,setIsLoadingComments] = React.useState(false)
    const [comments,setComments] = React.useState();

    async function loadComments(){

        setIsLoadingComments(true);

        try{

            const response = await axios.get(
                `${LOAD_FICHE_COMMENTS}/${fiche.id}`
            );

            setComments(response.data)

        } catch (e) {
            console.log(e)
        } finally {
            setIsLoadingComments(false)
        }

    }

    async function postComments(comment){

        setIsPostingComments(true);

        try{

            const response = await axios.post(
                `${LOAD_FICHE_COMMENTS}/${fiche.id}`,
                {
                    comment
                }
            );

            setComments(response.data)
            loadComments()

        } catch (e) {
            console.log(e)
        } finally {
            setIsPostingComments(false)
        }
    }

    React.useEffect(()=>{
        loadComments()
    },[])

    return (
        <div>

          <div className="h3">
              <span className={'d-inline-block mr-4'}>Messages</span>

              {
                  isLoadingComments && (
                      <CircularProgress size={14} />
                  )
              }
          </div>


            <div>

                {
                    comments && comments.map(
                        comment => {
                            return (
                                <div className={clsx([
                                    'my-5 position-relative'
                                ])}>

                                    <div  className={clsx([
                                        'my-5',
                                        classes.comment,
                                        {
                                            ['bg-light-primary text-primary']: comment.societe == 'CIE',
                                            ['bg-light-success text-success']: comment.societe == 'SODECI',
                                        }
                                    ])}>


                                        {
                                            comment.societe === 'CIE'
                                            && (
                                                <div className="mb-10">
                                                    <img src="/images/cie-logo.jpg" width={58} alt=""/>
                                                </div>
                                            )
                                        }

                                        {
                                            comment.societe === 'SODECI'
                                            && (
                                                <div className="mb-10">
                                                    <img src="/images/sodeci-logo.png" width={68} alt=""/>
                                                </div>
                                            )
                                        }
                                        { comment.comment }


                                    </div>

                                    <div>
                                        <span className="font-weight-bold small">{ moment(comment.created_at).format('D/MM/Y kk:mm') }</span>
                                    </div>



                                    {/*<div className={'text-right small mt-2 text-success font-weight-bold'}>*/}

                                    {/*    Envoyer le 12/12/2222 22:22 par <span>Jacob</span>*/}

                                    {/*</div>*/}

                                </div>
                            )
                        }
                    )
                }

            </div>



        </div>
    )
}